export default {
    props: {
        editor: {
            type: Object,
            required: true,
        },
        option: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['richTextMenu'],
    methods: {
        // Get the extension option from the RichTextMenu
        getExtensionOption(option) {
            return this.richTextMenu.getExtensionOption(option);
        },
        // Get the active style from the RichTextMenu
        activeStyle(option) {
            return this.richTextMenu.activeStyle(option);
        },
    },
};
